import React from 'react'
import styled from 'styled-components'
import { Starter } from '../Starter'
import { actions } from 'containers/AI/actions'
import { CursorInfo01Icon } from 'containers/AI/icons'
import { ThemeColors } from '@evrekadev/evreka-ui-components'
import { useAIContext } from 'containers/AI/context/AIProvider'
import { AIActions } from 'containers/AI/types'

export type QuestionMenuProps = {}

export const QuestionMenu: React.FC<QuestionMenuProps> = () => {
  const { setPage } = useAIContext()
  return (
    <QuestionMenuStyled className="fade-in">
      {actions.map((action) => (
        <Starter onClick={() => setPage(action.action)} {...action} />
      ))}
      <Starter
        onClick={() => setPage(AIActions.FEEDBACK)}
        icon={<CursorInfo01Icon height={40} width={40} color={ThemeColors.grey700} />}
        title="feedback.title"
        description="feedback.description"
        isSecondary
      />
    </QuestionMenuStyled>
  )
}

const QuestionMenuStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`
